<template>
	<div class="width-100 display-flex flex-row flex-justify-space-between flex-align-center">
		<div class="item-container display-flex flex-column flex-justify-center width-100">
			<div class="title-container display-flex flex-row width-100">
				<ApiDocsEditableTextField v-on="$listeners" ref="service_name" :text="item.service_name" :key="item.id" :id="item.id" />
			</div>
		</div>
		<AppDropdownMenu left bottom absolute min-width="265" :nudge-bottom="10" :items="optionsMenuItems">
			<template #activator="{}">
				<AnemicButton icon x-small rounded width="20" height="20" class="field-action-button">
					<AppIcon class="menu-button" name="menu-button" width="20" />
				</AnemicButton>
			</template>
		</AppDropdownMenu>
	</div>
</template>

<script>
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { useApiDoc } from '@/store/modules/aiAssistantApiDocs/getters';

import ApiDocsEditableTextField from './ApiDocsEditableTextField';
export default {
	name: 'ApiDocsSelectionItem',
	props: { item: { type: Object } },
	components: { ApiDocsEditableTextField },
	computed: {
		...mapGettersShorthand({ useApiDoc }),
		optionsMenuItems() {
			return [
				{ text: `Edit`, onClick: this.editApiDoc },
				{ text: `Delete`, onClick: this.delete },
			];
		},
	},
	methods: {
		async delete() {
			const res = await AppDialogManagerService.openDeleteApiDocDialog();
			if (res) {
				this.$emit('deleteApiDoc', this.item.id);
			}
		},
		async getApiDocDataFromDialog(apiDoc) {
			const props = apiDoc ? { apiDoc } : null;
			const value = (await AppDialogManagerService.openEditApiDocDialog(props)) || null;
			return value;
		},
		async editApiDoc() {
			const apiDoc = this.useApiDoc(this.item.id);
			const updatedApiDoc = await this.getApiDocDataFromDialog(apiDoc);
			if (!updatedApiDoc) {
				return;
			}
			try {
				this.$emit('editApiDoc', { id: this.item.id });
			} catch (error) {
				this.$toast.error(`Failed to update api docs name: ${error.response?.data?.error?.msg || error}`);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.menu-button {
	margin-top: 3px;
	margin-right: 2px;
}
.item-container {
	height: 34px;
	background: var(--bg-color) !important;

	&:hover {
		background: var(--selection-hover-background);
	}

	.title-container {
		background: var(--bg-color);
	}

	.description-container {
		font-size: 12px;
		color: #939baa;
	}
	.lock-icon {
		font-size: 14px;
	}
}
</style>
